import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStorePageAvailable } from '@/lib/store-availability';
import { HomePage } from './HomePage';

/**
 * `/marketplace`: the old store's home while the new Arche Store is switched
 * off, and — once it is on — straight to the Advanced search, the part of the
 * old store kept beside the new one (its home's featured list and categories
 * are what the new store replaces).
 */
export function OldStoreHome(): ReactElement {
  const available = useStorePageAvailable();
  const { search } = useLocation();
  if (available === true) return <Navigate to={`/marketplace/browse${search}`} replace />;
  return <HomePage />;
}
